import Parent from './parent';
import Child from './child';

let AcrossTabs = {
  Parent: Parent,
  Child: Child
};

export default AcrossTabs;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/index.js
 **/